import { render, staticRenderFns } from "./ReagentDilutionList.vue?vue&type=template&id=2d32c5ab&scoped=true&"
import script from "./ReagentDilutionList.vue?vue&type=script&lang=js&"
export * from "./ReagentDilutionList.vue?vue&type=script&lang=js&"
import style0 from "./ReagentDilutionList.vue?vue&type=style&index=0&id=2d32c5ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32c5ab",
  null
  
)

export default component.exports